import { Flex, Switch, Text } from '@mantine/core';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { StepProps } from 'src/UI/drawer-flow/DrawerFlow';
import SelectTemplateStep from 'src/UI/drawer-flow/SelectTemplateStep';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { useGenerateMeetingNote } from '../hooks/useGenerateMeetingNote';
import { MeetingNoteData } from '../MeetingNoteFlow';

export default function MeetingNoteSelectTemplateStep(props: StepProps<MeetingNoteData>) {
  const { generateMeetingNote, isLoading } = useGenerateMeetingNote();
  const { flagEnabledMeetingNoteSummarisation } = useFlags();
  const { data, setData } = props;

  const handleSummariseToggle = (checked: boolean) => {
    setData({ ...data, summarise: checked });
  };

  const handleGenerateMeetingNote = async () => {
    if (!props.data.client) {
      throw new Error('Client not found');
    }
    if (!props.data.selectedRecordingId) {
      throw new Error('Recording not selected');
    }
    if (!props.data.selectedTemplateId) {
      throw new Error('Template not selected');
    }
    try {
      await generateMeetingNote(props.data.client.id, {
        dataUploadFileId: props.data.selectedRecordingId,
        templateId: props.data.selectedTemplateId,
        summarise: props.data.summarise,
      });
      props.onSuccess();
    } catch (error) {
      notifyAndLogError('Error', 'Failed to generate meeting notes', error);
    }
  };
  return (
    <SelectTemplateStep
      {...props}
      type="MEETING_NOTE"
      description="Please choose a template which Siesta AI will use to base the client specific meeting note on."
      clientNameSuffix="meeting notes"
      continueText={isLoading ? 'Generating...' : 'Generate meeting note'}
      canGoForward={!isLoading}
      canGoBack={!isLoading}
      nextStep={handleGenerateMeetingNote}
      isSubmitting={isLoading}
      footer={
        flagEnabledMeetingNoteSummarisation && (
          <Flex justify="space-between" align="center">
            <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
              Summarise meeting note
            </Text>
            <Switch
              checked={data.summarise ?? true}
              onChange={event => handleSummariseToggle(event.currentTarget.checked)}
            />
          </Flex>
        )
      }
    />
  );
}
